module.exports = __webpack_public_path__ + "assets/img/Exchange_btn.780d4d3b.png";